// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const AccentGemFragmentDoc = gql`
    fragment accentGem on CatalogueAccentGem {
  __typename
  id
  quantity
  melee {
    caratWeight
    crystal {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    colors {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
    clarities {
      systemCode
      translation(locale: $locale) {
        name
      }
    }
  }
}
    `;